module.exports = __webpack_public_path__ + "img/loginBg1.ae9d95da.jpg";